import { FormControl, FormLabel } from "@material-ui/core";
import React from "react";
import { Input } from "reactstrap";
export function TextQuestion(props) {
  const { lang, onTextInput, question, answerList, pollTemplate } = props;
  const { questionLanguage, questionId } = question;
  const label = questionLanguage.find((ql) => ql.languageCode === lang)?.label ?? questionLanguage?.[0]?.label ?? "Missing Label";
  const answer = answerList.find((nl) => nl.questionId == questionId);
  const { textInput, questionTitle } = pollTemplate;
  return (
    <FormControl style={{ width: "100%", height: "100%" }} component="fieldset">
      <FormLabel component="legend" style={{ ...questionTitle }}>
        {label}
      </FormLabel>
      <Input style={{ ...textInput, height: "100%", resize: "none" }} onChange={(e) => onTextInput(questionId, e.target.value)} value={answer ? answer.value : ""} type="textarea" />
    </FormControl>
  );
}
